/**
 * AccidentOptions Component
 * 
 * Displays two option cards for accident documentation method selection.
 * Visual-only component - user speaks their choice, AI detects it.
 */

import React from 'react';
import './accident-options.scss';

interface AccidentOptionsProps {
  language: 'ar' | 'en' | 'ur';
}

const texts = {
  ar: {
    title: 'اختر طريقة التوثيق',
    option1Title: 'رفع الصور',
    option1Desc: 'ارفع صور من جوالك',
    option2Title: 'كاميرا مباشرة',
    option2Desc: 'افتح الكاميرا ووري الأضرار',
    instruction: 'قول "الخيار الأول" أو "الخيار الثاني"'
  },
  en: {
    title: 'Choose Documentation Method',
    option1Title: 'Upload Images',
    option1Desc: 'Upload photos from your phone',
    option2Title: 'Live Camera',
    option2Desc: 'Open camera and show damage',
    instruction: 'Say "option one" or "option two"'
  },
  ur: {
    title: 'دستاویز کرنے کا طریقہ منتخب کریں',
    option1Title: 'تصاویر اپ لوڈ کریں',
    option1Desc: 'اپنے فون سے تصاویر اپ لوڈ کریں',
    option2Title: 'لائیو کیمرا',
    option2Desc: 'کیمرا کھولیں اور نقصان دکھائیں',
    instruction: '"پہلا آپشن" یا "دوسرا آپشن" کہیں'
  }
};

export default function AccidentOptions({ language }: AccidentOptionsProps) {
  const t = texts[language];
  const isRTL = language === 'ar' || language === 'ur';

  return (
    <div className={`accident-options-container ${isRTL ? 'rtl' : 'ltr'}`}>
      <h3 className="options-title">{t.title}</h3>
      
      <div className="options-grid">
        {/* Option 1: Upload Images */}
        <div className="option-card">
          <div className="option-icon">
            <span className="material-symbols-outlined">add_photo_alternate</span>
          </div>
          <h4 className="option-title">{t.option1Title}</h4>
          <p className="option-description">{t.option1Desc}</p>
          <div className="option-number">1</div>
        </div>

        {/* Option 2: Live Camera */}
        <div className="option-card">
          <div className="option-icon">
            <span className="material-symbols-outlined">videocam</span>
          </div>
          <h4 className="option-title">{t.option2Title}</h4>
          <p className="option-description">{t.option2Desc}</p>
          <div className="option-number">2</div>
        </div>
      </div>

      <p className="instruction-text">{t.instruction}</p>
    </div>
  );
}
